<template>
  <div class="flex mt-2 ml-2 self-start" v-if="quiz_found >= 1">
    <div v-for="i in 5" :key="i" class="mr-1 w-2 h-5 bg-gray-400"
         :class="{ 'bg-green-400': value >= i * 20 }"></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [ 'id', 'type' ],
  data() {
    return {
      quiz_found: false,
      value: 0
    }
  },
  computed: {
    ...mapGetters(['calc_subject_quiz_result', 'calc_topic_quiz_result'])
  },
  created() {
    let x
    switch (this.type) {
      case 'subject':
        x = this.calc_subject_quiz_result( this.id )
        break
      case 'topic':
        x = this.calc_topic_quiz_result( this.id )
        break
    }
    this.value = x['result']
    this.quiz_found = x['quiz_length']
  },
}
</script>